var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("influencer_group.title"))),
          ]),
          _c("small", { staticClass: "text-muted d-block mb-3" }, [
            _vm._v(_vm._s(_vm.$t("influencer_group.hint"))),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-6/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_group.name"),
                      "label-for": "name",
                    },
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: { id: "name", type: "text" },
                      model: {
                        value: _vm.model.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "name", $$v)
                        },
                        expression: "model.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-6/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_group.status"),
                      "label-for": "status",
                    },
                  },
                  [
                    _c("b-form-radio-group", {
                      attrs: { id: "status", options: _vm.statusList },
                      model: {
                        value: _vm.model.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "status", $$v)
                        },
                        expression: "model.status",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("influencer_group.description"),
                "label-for": "description",
              },
            },
            [
              _c("b-form-textarea", {
                attrs: { id: "description", rows: "2" },
                model: {
                  value: _vm.model.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "description", $$v)
                  },
                  expression: "model.description",
                },
              }),
            ],
            1
          ),
          _vm.isEdit
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("influencer_group.members"),
                    "label-for": "members",
                  },
                },
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "w-full",
                      attrs: {
                        id: "members",
                        options: _vm.influencers,
                        reduce: function (opt) {
                          return opt.id
                        },
                        label: "name",
                        multiple: "",
                      },
                      model: {
                        value: _vm.model.influencer_ids,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "influencer_ids", $$v)
                        },
                        expression: "model.influencer_ids",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("influencer_group.no_influencers"))
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_group.members_hint"))),
                  ]),
                ],
                1
              )
            : _c(
                "b-alert",
                {
                  staticClass: "p-1 mb-0",
                  attrs: { variant: "primary", show: "" },
                },
                [
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.$t("influencer_group.members_after_save"))
                    ),
                  ]),
                ]
              ),
          _c(
            "b-form-row",
            { staticClass: "justify-end mt-2" },
            [
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.createOrUpdate },
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.goBack },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "CornerUpLeftIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("back"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }